module.exports = __webpack_public_path__ + "static/media/zy_swiper.70e7be78.jpg";